import React, { useEffect, useRef } from "react";
import "./earringsShop.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Earring_1 from "./images/earrings_1.webp";
import Earring_2 from "./images/earrings_2.webp";
import Earring_3 from "./images/earrings_3.webp";
import Earring_4 from "./images/earrings_4.webp";
import Earring_5 from "./images/earrings_5.webp";
import Video1 from "./images/video_1.mp4";
import ShopIcon from "../../../images/shop.svg";
export default function earringsShop() {
  return (
    <div className="earringsShop-main">
      <div className="earringsShop-container">
        {/* <div className="earringsShop-element earringsShop-video"></div> */}
        <video
          playsinline="true"
          autoplay="true"
          loop="true"
          muted="true"
          className="earringsShop-element earringsShop-video"
        >
          <source
            src={
              "https://cdn.media.amplience.net/v/teilor/Natalia site patrat 1/mp4_720p"
            }
            type="video/mp4"
          />
        </video>
        <div className="earringsShop-element earringsShop-product-1">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/kolczyki-z-bialego-zlota-18k-z-diamentami-4-2ct-55488.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/kolczyki-z-biaego-zota-18k-z-diamentami-42ct_23828_1_1653919975.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="earringsShop-element earringsShop-product-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/kolczyki-z-bialego-18-karatowego-zlota-z-brylantami-o-masie-5-17-ct-55487.html
            "
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/kolczyki-z-biaego-18karatowego-zota-z-brylant_23827_1_16539829980159.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="earringsShop-element earringsShop-product-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/kolczyki-z-18k-bialego-zlota-z-3ct-czarnymi-diamentami-i-2-2ct-bezbarwnymi-diamentami-121658.html
            "
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/kolczyki-z-18k-biaego-zota-z-3ct-czarnymi-diamentami-i-22ct-bezbarwnymi-diamentami_3097859_1_1653917621.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="earringsShop-element earringsShop-product-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/kolczyki-z-14k-bialego-zlota-z-5-23ct-tanzanitami-i-0-69ct-diamentami-111145.html
            "
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/kolczyki-z-14k-biaego-zota-z-523ct-tanzanitami-i-069ct-diamentami_2672534_1_1653917619.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="earringsShop-element earringsShop-product-5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/kolczyki-z-bialego-zlota-18-karatowego-z-diamentami-0-257ct-i-szafirami-0-444ct-121717.html
            "
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/kolczyki-z-biaego-zota-18karatowego-z-diamentami-0257ct-i-szafirami-0444ct_3115115_1_1653919975.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
      </div>
      <div className="component-button">
        <div className="component-button-border"></div>
        <div className="component-button-text">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pure-diamonds/filtre/rodzaj-bizuterii-kolczyki.html"
          >
            ODKRYJ KOLCZYKI
          </a>
        </div>
      </div>
    </div>
  );
}
